export const extName = "liplum-html-widget"
